import { render, staticRenderFns } from "./StatsProgram.vue?vue&type=template&id=126a3aa9&"
import script from "./StatsProgram.vue?vue&type=script&lang=js&"
export * from "./StatsProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports